module.exports = __webpack_public_path__ + "img/48d4138.jpg";